export enum chatTypes {
    FETCH_CHAT_LINKS_REQUEST = 'FETCH_CHAT_LINKS_REQUEST',
    FETCH_CHAT_LINK_REQUEST = 'FETCH_CHAT_LINK_REQUEST',
    EDIT_CHAT_LINKS_REQUEST = 'EDIT_CHAT_LINKS_REQUEST',
    CREATE_CHAT_LINKS_REQUEST = 'CREATE_CHAT_LINKS_REQUEST',
    DELETE_CHAT_LINKS_REQUEST = 'DELETE_CHAT_LINKS_REQUEST',
    SET_CHAT_LINKS = 'SET_CHAT_LINKS',
    SET_RELATIVE_CHAT = 'SET_RELATIVE_CHAT',
}
